import { Component, Input, OnInit } from '@angular/core';
import { ReportService } from "../../../services/report.service";
import { take } from 'rxjs/operators';
import { SubmissionsService } from 'src/app/services/submissions.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss']
})
export class LegendComponent implements OnInit {
  submissionId: string;

  constructor(private reportService: ReportService, private submissionsService: SubmissionsService, private route: ActivatedRoute, private spinnerService: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.reportService.toggleQuotesObject.subscribe((data) => {
      this.toggleChecked = data;
    });
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.submissionId = params.get('id');
    });

  }

  @Input() isOnAi!: boolean;
  @Input() isOnAnalysis!: boolean;
  @Input() isOnManipulation!: boolean;
  @Input() isAiEnabled: boolean = false;
  @Input() hasTranslatedLanguages: boolean = false;
  @Input() hasAiAnalysis: boolean = false;
  @Input() hasManipulations: boolean = false;
  // @Input() toggleChecked: boolean
  @Input() context_similarity: boolean
  toggleChecked

  // Add aria label for toggle
  toggleAriaLabel = 'Toggle cited text highlighting';

  // Add keyboard handler for toggle
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleQuotes();
    }
  }

  toggleQuotes() {
    this.toggleChecked = !this.toggleChecked;
    this.reportService.toggleQuotesSubject.next(this.toggleChecked);
  }
}
